//#region IMPORT
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import M_TBM_BASIC_01 from './M_TBM_BASIC_01';
import { Loading } from '../../../Components/MUIs';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_BASIC_01F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const { userInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보
  //
  const [state, setState] = useState({
    bottom: false,
    type: '',
  }); // 드로워 상태값
  const [imageFile, setImageFile] = useState({
    //이미지 설정
    mapFiles: '', //파일 String
    mapImage: '', // 파일 정보
  });
  const [total, setTotal] = useState(200);
  const [completed, setCompleted] = useState(0);
  //#endregion

  // 스택형 뒤로가기로 변경: TBM 시작 단계 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEm' })),
  });

  useEffect(() => {
    Init();
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);

  const Init = async () => {
    setLoading(true);

    try {
      SearchPhoto();
      await SearchLogic2(); // 당월 진행상황 조회
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  //사진 가져오기
  const SearchPhoto = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(userInfo.photo),
        }
      ).then((result) => {
        let data = result.data;

        if (data !== 'Error') {
          setImageFile({
            ...imageFile,
            mapFiles: `data:image/png;base64,${data}`,
            mapImage: {
              name: userInfo.photo.split('/')[
                userInfo.photo.split('/').length - 1
              ],
            },
          });
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  // 당월 진행사항
  const SearchLogic2 = async () => {
    setLoading(true);
    setCompleted(0);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R3',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Error') {
            throw new Error(data[0].message);
          } else {
            setCompleted(data[0].COMPLETE);
          }
        } else {
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장

  //#endregion
  //#region 삭제
  const DeleteLogic1 = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_MEMBER_D2',
            _USER_ID: userInfo.userid,
            _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current),
          },
        ]
      );
    } catch (error) {
      console.error(error);
    }
  };
  //#endregion
  //#region 나머지 함수
  // 드로워 상태값 관리
  const ToggleDrawer = (anchor, open, gubun) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open, gubun: gubun });
  };
  //#endregion
  return (
    <div className="wrap">
      <M_TBM_BASIC_01
        userInfo={userInfo}
        state={state}
        setState={setState}
        gjList={props.gjList}
        imageFile={imageFile}
        setImageFile={setImageFile}
        setModalToggle1={props.setModalToggle1}
        modalToggle1={props.modalToggle1}
        setModalToggle2={props.setModalToggle2}
        modalToggle2={props.modalToggle2}
        total={total}
        setTotal={setTotal}
        completed={completed}
        setCompleted={setCompleted}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        userCount={props.userCount}
        setUserCount={props.setUserCount}
        // 함수
        ToggleDrawer={ToggleDrawer}
        DeleteLogic1={DeleteLogic1}
        ActiveButton={props.ActiveButton}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TBM_BASIC_01F;
